import { useQuery } from '@apollo/client/react'
import { Box } from '@mui/material'
import { StepProgress } from 'settle-ui/components/StepProgress/StepProgress'
import { useOnboardingLayoutContext } from 'routes/components/OnboardingLayout/hooks/useOnboardingLayoutContext/useOnboardingLayoutContext'
import { getOnboardingSteps } from './helpers/getOnboardingSteps/getOnboardingSteps'
import { OnboardingStepperDocument } from './OnboardingStepper.graphql'

export const OnboardingStepper = () => {
  const { flowType } = useOnboardingLayoutContext()

  const { data: { onboardingFlows = [] } = {} } = useQuery(OnboardingStepperDocument)
  const onboardingFlow = onboardingFlows.find((flow) => flow.flowType === flowType)

  if (!onboardingFlow) {
    return null
  }

  return (
    <Box sx={{ mb: 1 }}>
      <StepProgress steps={getOnboardingSteps(onboardingFlow)} />
    </Box>
  )
}
